<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>
<script>
export default {
  name: "App",
  components: {}
};
</script>

<style>
html,
body {
  height: 100%;
}
* {
  margin: 0;
  padding: 0;
}
li {
  list-style: none;
}
/* overflow: hidden; /*这里不写可能会导致底部出现白边或滚动条*/ 
#app {
  height: 100%;
  min-height: 100vh; /*最小高度*/
  
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  position: relative;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

</style>
